import React from "react";
import { Box, Button } from "@mui/material";

import { MultiLayerUploadSections } from "fond/project/panels/InputPanel/MultiLayerUploadForm";
import LayerGroupUploadForm from "fond/project/panels/upload/LayerGroupUploadForm";

import { BaseDataLayerKey } from "../layers";

import { getBaseDataLayerGroupId, MULTI_LAYER_UPLOAD_SECTIONS } from "./layerGroups";

interface UploadSectionProps {
  layerKey: BaseDataLayerKey;
  /** Called once the upload succeeds, or the user cancels it. */
  onComplete(): void;
}

/**
 * The expanded Upload option: an inline upload form, replace confirmation and upload progress for the layer.
 */
const UploadSection: React.FC<UploadSectionProps> = ({ layerKey, onComplete }) => {
  const layerGroupId = getBaseDataLayerGroupId(layerKey);
  const multiLayerSections = MULTI_LAYER_UPLOAD_SECTIONS[layerKey];

  if (!layerGroupId) return null;

  if (multiLayerSections) {
    return (
      <Box px={1}>
        <MultiLayerUploadSections sections={multiLayerSections} />
        <Box display="flex" justifyContent="flex-end">
          <Button size="small" onClick={onComplete}>
            Done
          </Button>
        </Box>
      </Box>
    );
  }

  return <LayerGroupUploadForm layerGroupId={layerGroupId} showLayerName={false} onCancel={onComplete} onSuccess={onComplete} />;
};

export default UploadSection;
